import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types';
import { formatViews } from '@/utils/format';

interface NewsListItemProps {
  item: NewsItem;
}

export default function NewsListItem({ item }: NewsListItemProps) {
  return (
    <article className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-300 sm:flex-row">
      <Link
        to={`/detail/news/${item.id}`}
        className="block h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-100 sm:h-32 sm:w-48"
      >
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} 黄金投资资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
            {item.tag}
          </span>
          <span className="text-xs text-foreground-400">{item.date}</span>
        </div>

        <h3 className="mt-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          <Link to={`/detail/news/${item.id}`}>{item.title}</Link>
        </h3>

        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>

        <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" aria-hidden="true"></i>
            {item.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>
            {formatViews(item.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" aria-hidden="true"></i>
            {item.readTime}
          </span>
        </div>
      </div>
    </article>
  );
}